import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { requireAuth } from '@/utils';

export const Route = createFileRoute('/_admin')({
  beforeLoad: () => requireAuth(),
  component: () => (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
});
